import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { TransinetClaimRequestDto } from "@helper/abstraction/transinet";
import { DeliverySystemDataDto } from "@helper/abstraction/ewaybill";
import { ConfigurationService } from "@core/configuration.service";
import { DocumentController } from "./document-controller";

export class Transinet extends DocumentController<any> {
	public get apiUrl(): string { 
		return `${this.config.api.delivery}`; 
	}

	constructor(
		private config: ConfigurationService,
		http: HttpClient
	) {
		super(http);
	}

	public claims = {
		create: {
			post$: (data: TransinetClaimRequestDto, documentId: number): Observable<DeliverySystemDataDto> => {
				const url = `${this.apiUrl}/TRANSINET/claim`;

				let params = new HttpParams();
				params = params.set("documentId", documentId);
				return this.http.post<DeliverySystemDataDto>(url, data, { params });
			}
		},
		info: {
			get$: (claim_id: string): Observable<DeliverySystemDataDto> => {
				const url = `${this.apiUrl}/TRANSINET/claim/${claim_id}`;

				return this.http.get<DeliverySystemDataDto>(url, {});
			}
		},
		cancel: {
			post$: (claim_id: string): Observable<void> => {
				const url = `${this.apiUrl}/TRANSINET/claim/${claim_id}/cancel`;

				return this.http.post<void>(url, null);
			}
		},
	};
}
